(() => {
jQuery(function($) {
    $('#search-boletim').on('click', function(e) {
        e.preventDefault();
        Swal.fire({
            title: 'Pesquisar Boletim',
            html: `
                <form id="searchForm" action="` + phpVars.searchUrl + `" method="GET">
                    <label for="texto">
                        <span class="screen-reader-text">Buscar por:</span>
                        <input type="text" title="Search for:" name="texto" value="" id="texto" placeholder="Buscar por" class="search-form__field">
                        <div class="search_submit">
                            <img src="` + phpVars.iconImg + `" alt="">
                        </div>
                    </label>
                </form>
            `,
            showConfirmButton: false,
            focusConfirm: false,
            didOpen: ()=>{
                $('#searchForm').on('submit', function(e) {
                    e.preventDefault();
                    const query = $.trim($(this).find('[name="texto"]').val());
                    if (query !== '') {
                        const action = $(this).attr('action');
                        window.location.href = `${action}?texto=${encodeURIComponent(query)}&filter_section=boletim`;
                    }
                });
            }
        });
    });
});


jQuery(document).ready(function($) {
    $('#boletins-count').on('click', function() {
        const total = parseInt($(this).data('count'), 10) || 0;
        const offset = $('.boletim-card').length;
        if (offset >= total) {
            $(this).hide();
            return;
        }
        const searchText = $(this).data('text');
        $.ajax({
            url: phpVars.ajaxUrl,
            method: 'POST',
            data: {
                action: 'get_post_search_limited',
                text: searchText,
                offset: offset
            },
            beforeSend: function() {
                $('#boletins-count').prop('disabled', true);
            },
            success: function(response) {
                if (response.success && response.data.length) {
                    response.data.forEach(function(item) {
                        const cardHtml = `
                            <div class="page-support__card boletim-card">
                                <a href="${item.permalink}">
                                    <div class="page-support__card-image" style="background-image:url('');"></div>
                                </a>
                                <div class="page-support__card-content">
                                    <a href="${item.permalink}">
                                        <h3>Boletim n\xba ${item.title}</h3>
                                    </a>
                                    <p>${item.emphasis}</p>
                                    <div class="page-support__card-actions">
                                        <a href="${item.permalink}">Acesse</a>
                                    </div>
                                </div>
                            </div>
                        `;
                        $('.page-support__main--boletim').append(cardHtml);
                    });
                    const newCount = $('.boletim-card').length;
                    if (newCount >= total) $('#boletins-count').hide();
                    else $('#boletins-count').prop('disabled', false);
                } else $('#boletins-count').hide();
            },
            error: function() {
                console.error('Erro ao buscar boletins.');
                $('#boletins-count').prop('disabled', false);
            }
        });
    });
});


jQuery(document).ready(function($) {
    jQuery('.archive-single-button').on('click', function(e) {
        e.preventDefault();
    });
});



})();
//# sourceMappingURL=index.js.map
